module.exports = __webpack_public_path__ + "static/media/money.421688de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/web/pages/promocoes/money.svg
// module id = 1055
// module chunks = 0